export const EXPERIMENT_KEY =
  "fdr-show-a-new-option-talent-picks-in-the-more-menu";
